export default {
  auth: {
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password/:hash',
  },
  users: {
    profile: '/profile',
    idVerification: '/profile/id-verification',
    payout: '/profile/payout',
    scaEnroll: '/profile/sca-enroll',
  },
  reviews: {
    root: '/reviews',
    add: '/reviews/new/:cottageId/:bookingId?',
    edit: '/reviews/edit/:id',
  },
  conversations: {
    root: '/conversations',
    read: '/conversations/:conversationId',
    booking: '/conversations/:conversationId/bookings/:bookingId',
    bookings: '/conversations/:conversationId/bookings',
    newBooking: '/conversations/:conversationId/bookings/new',
    editBooking: '/conversations/:conversationId/bookings/:bookingId/edit',
  },
  bookings: {
    root: '/bookings',
  },
  hostFiles: {
    root: '/files',
    cottage: '/files/:cottageId',
  },
  complaints: {
    root: '/complaints',
    new: '/complaints/new',
    edit: '/complaints/:id/edit',
    detail: '/complaints/:id',
  },
  hostComplaints: {
    root: '/host/complaints',
    detail: '/host/complaints/:id',
  },
  cottages: {
    root: '/cottages',
    create: '/cottages/new',
    edit: '/cottages/:cottageId',
    editStep: '/cottages/:cottageId/:dialog?',
    createFixed: '/cottages/new/fixed',
    verify: '/cottages/:cottageId/verify',
    payment: '/cottages/:cottageId/payment',
  },
};
